export default {
  default: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/layouts/default.vue"),
  guest: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/layouts/guest.vue"),
  impressao: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/layouts/impressao.vue")
}